// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14gid","top":"styles_top__WGK76","left":"styles_left__21ScS","description":"styles_description__23uyv"};